import { useEffect, useState } from 'react'
import { loadRuntimeConfig, type RuntimeConfig } from '../lib/runtime-config'

export function SupportPage() {
  const [config, setConfig] = useState<RuntimeConfig | null>(null)
  const [error, setError] = useState('')
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    void loadRuntimeConfig()
      .then(setConfig)
      .catch((caught: Error) => setError(caught.message))
  }, [])

  return (
    <div className="page narrow-page">
      <header className="page-header">
        <span className="eyebrow">支持 iLoveSing</span>
        <h1>讓這個免費工具繼續維持</h1>
        <p>如果 iLoveSing 對排練或聚會有幫助，你可以自由選擇是否支持；不影響任何功能。</p>
      </header>
      {error && <div className="alert alert--danger">{error}</div>}
      {!config ? (
        <p className="page-status">正在讀取支持資訊…</p>
      ) : (
        <section className="donation-card">
          <div className="donation-copy">
            <span className="eyebrow">銀行轉帳</span>
            <h2>
              {config.donation.bankName}（{config.donation.bankCode}）
            </h2>
            <p>掃描 QR Code，或複製帳號到你的銀行 App。</p>
            <div className="account-copy">
              <code>{config.donation.account.replace(/(\d{3})(?=\d)/g, '$1 ')}</code>
              <button
                className="button button--primary"
                type="button"
                onClick={() => {
                  void navigator.clipboard.writeText(config.donation.account).then(() => {
                    setCopied(true)
                    window.setTimeout(() => setCopied(false), 1800)
                  })
                }}
              >
                {copied ? '已複製' : '複製帳號'}
              </button>
            </div>
            <div className="alert">
              轉帳前請再次確認銀行、帳號與金額。iLoveSing 不會透過私訊要求你提供密碼、驗證碼或操作 ATM。
            </div>
          </div>
          <img className="donation-qr" src={config.donation.qrImage} alt={`${config.donation.bankName}收款 QR Code`} />
        </section>
      )}
      <p className="legal-note">支持款項為自願提供，不是購買功能、訂閱或投資，也不保證特定開發時程。</p>
    </div>
  )
}

